import React from 'react';
import { Search } from 'lucide-react';

interface DocumentTypeSearchProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

export default function DocumentTypeSearch({
  searchTerm,
  onSearchChange,
}: DocumentTypeSearchProps) {
  return (
    <div className="w-full bg-white rounded-lg shadow-md p-4">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none z-10" />
        <input
          type="text"
          placeholder="Cari jenis dokumen..."
          value={searchTerm}
          onChange={e => onSearchChange(e.target.value)}
          className="w-full pl-10 pr-4 py-2.5 bg-white border border-gray-200 rounded-lg text-sm placeholder:text-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
        />
      </div>
    </div>
  );
}
